import { FcGoogle } from "react-icons/fc";
import { AUTH_PROVIDERS, REDIRECT_URL } from "../../config/constant";
import zohoLogo from "../../webroot/images/zoho.png";

function SsoLoginComponent() {
  return (
    <div className="d-flex login-div">
      <button type="button" className="btn-line m-md-l btn-google">
        <FcGoogle className="" />
        <a
          className="m-xs-l"
          href={
            REDIRECT_URL.replace(/%provider%/, AUTH_PROVIDERS.GOOGLE) +
            window.location.href
          }
        >
          Sign in with Google
        </a>
      </button>
      <button type="button" className="btn-line m-md-l btn-google">
        <img src={zohoLogo} alt="zoho-logo" />
        <a
          className="m-xs-l"
          href={
            REDIRECT_URL.replace(/%provider%/, AUTH_PROVIDERS.ZOHO) +
            window.location.href
          }
        >
          Sign in with Zoho
        </a>
      </button>
    </div>
  );
}

export default SsoLoginComponent;
